import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        flexContainer: {
            flexDirection: 'column',
        },
        productHeaderContainer: {
            width: '100%',
        },
        breadcrumbContainer: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            backgroundColor: 'background.default',
        },
        productContainer: {
            display: 'flex',
            flexDirection: ['column', 'column', 'column', 'row'],
            mt: ['small.base', 'small.sm', 'medium.md', 'medium.lg'],
            mb: ['small.base', 'small.sm', 'medium.md', 'medium.lg'],
            alignItems: ['center', 'center', 'center', 'flex-start'],
            justifyContent: ['center', 'center', 'center', 'unset'],
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
        },
        imageGalleryBox: {
            flex: 1,
            mr: [0, 0, 0, remCalc(24), remCalc(24)],
            width: ['100%', '100%', '100%', '67%'],
        },
        productCard: {
            display: 'flex',
            width: ['100%', '100%', '100%', '33%'],
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: [remCalc(20), remCalc(20), remCalc(20), remCalc(40)],
            flexShrink: 0,
            pt: [remCalc(20), remCalc(20), remCalc(20), 0],
        },
        priceBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(24),
            width: '100%',
        },
        klarnaBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        inventoryLabelContainer: {
            pt: [remCalc(24), remCalc(24), remCalc(24), remCalc(16)],
        },
        horizontalDivider: {
            color: 'border.light',
            display: ['block', 'block', 'block', 'none'],
        },
        energyLabel: {
            mt: remCalc(-16),
        },
    },
}
